import React from "react";
import { PayPalButton } from "react-paypal-button-v2";

const PayPal = (props) => {
  const {
    amount,
    currency,
    createSubscription,
    onApprove,
    catchError,
    onError,
    onCancel,
  } = props;
  const paypalKey = "AcJqqKKABAzp3MHEnYhngnLwNY2e9liPLcM4ajpTxmpD1SkKGIJg2N6kXRO_ob-F6265Bexck5vQXUjr";

  return (
    <PayPalButton
      amount={amount}
      currency={currency}
      createSubscription={(data, details) => createSubscription(data, details)}
      onApprove={(data, details) => onApprove(data, details)}
      onError={(err) => onError(err)}
      catchError={(err) => catchError(err)}
      onCancel={(err) => onCancel(err)}
      options={{
        clientId: paypalKey,
        vault: true,
      }}
      style={{
        shape: "rect",
        color: "blue",
        layout: "horizontal",
        label: "subscribe",
      }}
    />
  );
}

export default PayPal;
